"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/button-has-type */
/* eslint-disable dot-notation */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const CatalogHeader_module_scss_1 = __importDefault(require("./CatalogHeader.module.scss"));
function CategoryHeader() {
    var _a;
    const currentSeries = (0, react_redux_1.useSelector)(selectors_1.selectCatalogSeries);
    const currentCategoryGroup = (0, react_redux_1.useSelector)(selectors_1.selectCatalogCategoryGroup);
    const disableFeatures = (_a = Viewer_1.default.instance.getDesignProMain()) === null || _a === void 0 ? void 0 : _a.disableFeatures;
    const { dispatchSetCatalogCategoryGroup, dispatchSelectItem } = (0, redux_1.bindActionCreators)({
        dispatchSetCatalogCategoryGroup: actions_1.setCatalogCategoryGroup,
        dispatchSelectItem: actions_1.selectItem,
    }, (0, react_redux_1.useDispatch)());
    const backButtonClickHandler = () => {
        dispatchSetCatalogCategoryGroup(null);
        dispatchSelectItem(null);
    };
    if (!currentCategoryGroup || !currentSeries) {
        return null;
    }
    return (react_1.default.createElement("div", { className: CatalogHeader_module_scss_1.default['container'] },
        react_1.default.createElement("button", { disabled: disableFeatures, className: CatalogHeader_module_scss_1.default['back-button'], onClick: () => backButtonClickHandler() },
            react_1.default.createElement("img", { src: assets_1.svgLightChevronLeft, role: "presentation" }),
            "Back"),
        react_1.default.createElement("div", null,
            currentSeries.name,
            " - ",
            currentCategoryGroup.name)));
}
exports.default = CategoryHeader;
